module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_4.b5b0326.jpg";